import { useState } from "react";
import { CANT_SEE_SOME_STORES } from "../../text-data";
import { ToolTipsSvg } from "../../components/Assets";
import SmallBanner from "../../components/SmallBanner";
import BottomSheet from "../../components/modal/BottomSheet";
import CantSeeSomeStoreGuide from "./CantSeeSomeStoreGuide";
const CantSeeSomeStore = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const onTooltips = () => {
    setIsOpen(true);
  };
  return (
    <>
      <SmallBanner className={""}>
        <div className="inline-flex w-full justify-center gap-1 items-center text-sm">
          <span>👀</span>
          <span>{CANT_SEE_SOME_STORES}</span>
          <img src={ToolTipsSvg} className="w-4 h-4" onClick={onTooltips} />
        </div>
      </SmallBanner>
      <BottomSheet isOpen={isOpen} closeModal={closeModal}>
        <CantSeeSomeStoreGuide closeModal={closeModal} />
      </BottomSheet>
    </>
  );
};

export default CantSeeSomeStore;
